import React, {createContext, useContext, useEffect, useMemo, useState} from "react";
import {checkFirstUser} from "../services/requests/ApiRequests";
import {getCurrentUser} from "../services/requests/GraphRequests";

const AuthContext = createContext({
	user: null,
	loading: true,
	error: null,
	refresh: async () => {
	},
});

export const AuthProvider = ({children}) => {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [firstAdmin, setFirstAdmin] = useState(null);

	const fetchUser = async () => {
		setLoading(true);
		setError(null);
		try {
			const resFirstAdmin = await checkFirstUser()
			const res = await getCurrentUser();

			const current = res?.data?.currentUser || null;

			setUser(current);

			setFirstAdmin(resFirstAdmin.data.users_created)
		} catch (e) {
			setError(e);
			// console.log(e);
			setUser(null);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchUser();
	}, []);


	const value = useMemo(
		() => ({user, loading, error, refresh: fetchUser, firstAdmin}),
		[user, loading, error, firstAdmin]
	);


	return (
		<AuthContext.Provider value={value}>{children}</AuthContext.Provider>
	);
};

export const useAuth = () => useContext(AuthContext);
